import { FieldWrapper } from "@/forms/field-wrapper";
import { Checkbox } from "@/components/ui/checkbox";
import { useFormContext } from "react-hook-form";
import { cn } from "@/lib/utils";
import { makeLabel } from "@/forms/helpers";
import { FormLabel } from "@/components/ui/form";

export function CheckboxField({
  field,
  disabled = false,
  onChange = () => {},
  extraLabel = undefined,
  labelClassName = undefined,
  wrapperClassName,
  checkboxClassName,
  color,
  id,
}: FormField & {
  id?: string;
  extraLabel?: string;
  wrapperClassName?: string;
  checkboxClassName?: string;
  color?: "defult" | "black";
}) {
  const { control } = useFormContext();
  return (
    <FieldWrapper
      field={field}
      control={control}
      wrapperClassName={wrapperClassName}
      disabled={disabled}
      shouldRenderLabel={false}
      labelClassName={labelClassName}
      renderComponent={(formField) => {
        return (
          <div className={cn("flex gap-2", "items-start")}>
            <Checkbox
              {...formField}
              onCheckedChange={(value) => {
                formField.onChange(value);
                onChange(value);
              }}
              defaultChecked={!!field.value}
              id={id ?? field.name}
              className={cn(
                "translate-y-0.5 cursor-pointer bg-white",
                color === "black" && "data-[state=checked]:bg-black",
                checkboxClassName,
              )}
            />
            <>
              <FormLabel
                dangerouslySetInnerHTML={{ __html: makeLabel(field) }}
                className={cn(
                  "[&_a]:hover:text-remedium-blue! text-muted-foreground block cursor-pointer [&_a]:text-black! [&_a]:underline!",
                  labelClassName,
                  extraLabel && "mb-1.5 font-semibold",
                )}
                htmlFor={id ?? field.name}
              />
              {extraLabel && (
                <div
                  className={`text-muted-foreground text-xs font-normal`}
                  dangerouslySetInnerHTML={{ __html: extraLabel }}
                />
              )}
            </>
          </div>
        );
      }}
    />
  );
}
